import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { affiliateApi } from '../services/influancerService';
import Navbar from '../../components/Navbar';


const AffiliateRedirect = () => {
  const { shortCode } = useParams();

  useEffect(() => {
    const redirect = async () => {
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const fingerprint = result.visitorId;

        const response = await affiliateApi.handleLinkClick(shortCode, fingerprint);

        if (!response?.clickId || !response?.actualLink) {
          window.location.href = "/";
          return;
        }

        // Store click data locally
        localStorage.setItem("inf_clickId", response.clickId);
        localStorage.setItem("inf_shortCode", shortCode);
        localStorage.setItem("inf_fingerprint", fingerprint);
        localStorage.setItem("inf_clickTime", Date.now().toString());

        // Redirect to company site
        window.location.href =
          `${response.actualLink}?clickId=${response.clickId}&shortCode=${shortCode}`;

      } catch (error) {
        console.error("Redirect error:", error);
        window.location.href = "/";
      }
    };

    redirect();
  }, [shortCode]);

  return (
    <>
      <div className="flex flex-col items-center justify-center min-h-screen bg-orange-500 relative">
        <Navbar />
        {/* Connecting Icon */}
        <div className="animate-spin mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-16 w-16 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.354a8.001 8.001 0 11-4.244 14.907M4.354 12a8.001 8.001 0 0114.907-4.244"
            />
          </svg>
        </div>

        {/* Connecting Text */}
        <div className="text-center text-white">
          <h1 className="text-xl font-semibold">Redirecting to the product</h1>
          <p className="text-sm mt-2">This shouldn't take long</p>
        </div>
      </div>
    </>
  );
};

export default AffiliateRedirect;



// import { useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import { affiliateApi } from '../services/influancerService';
// // import Loading from '../components/Loading';
// import FingerprintJS from '@fingerprintjs/fingerprintjs';
// import Navbar from '../../components/Navbar';

// const AffiliateRedirect = () => {
//   const { shortCode } = useParams();

//   useEffect(() => {
//     const redirectToProduct = async () => {
//       try {
//         // Initialize FingerprintJS
//         const fp = await FingerprintJS.load();
//         const result = await fp.get();
//         const fingerprint = result.visitorId;

//         console.log('Fingerprint:', fingerprint);

//         // Send both fingerprint and handle redirect
//         const response = await affiliateApi.handleLinkClick(shortCode, fingerprint);

//         if (!response.clickId) {
//           console.error('No clickId received, possible backend issue');
//           return;
//         }

//         // Store tracking data in both localStorage and cookies
//         const clickTimestamp = Date.now().toString();

//         // Store in localStorage
//         localStorage.setItem('lastClickId', response.clickId);
//         localStorage.setItem('shortCode', shortCode);
//         localStorage.setItem('deviceFingerprint', fingerprint);
//         localStorage.setItem('clickTimestamp', clickTimestamp);

//         // Set cookies with security attributes
//         const cookieOptions = 'max-age=new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString(); path=/; Secure; SameSite=None';
//         document.cookie = `lastClickId=${response.clickId}; ${cookieOptions}`;
//         document.cookie = `shortCode=${shortCode}; ${cookieOptions}`;
//         document.cookie = `clickTimestamp=${clickTimestamp}; ${cookieOptions}`;
//         document.cookie = `deviceFingerprint=${fingerprint}; ${cookieOptions}`;

//         if (response.actualLink) {
//           const redirectUrl = `${response.actualLink}?lastClickId=${response.clickId}&deviceFingerprint=${fingerprint}&shortCode=${shortCode}&clickTimestamp=${clickTimestamp}`;
//           console.log('Redirect URL:', redirectUrl);
//           window.location.href = redirectUrl;
//         } else {
//           console.error('No redirect URL received');
//           window.location.href = '/';
//         }
//       } catch (error) {
//         console.error('Redirect error:', error);
//         window.location.href = '/';
//       }
//     };

//     redirectToProduct();
//   }, [shortCode]);

//   // return <Loading />;

//   return <div className="flex flex-col items-center justify-center min-h-screen bg-orange-500 relative">
//     <Navbar />
//     {/* Top Status Bar Mock */}


//     {/* Connecting Icon */}
//     <div className="animate-spin mb-4">
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         className="h-16 w-16 text-white"
//         fill="none"
//         viewBox="0 0 24 24"
//         stroke="currentColor"
//         strokeWidth={2}
//       >
//         <path
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           d="M12 4.354a8.001 8.001 0 11-4.244 14.907M4.354 12a8.001 8.001 0 0114.907-4.244"
//         />
//       </svg>
//     </div>

//     {/* Connecting Text */}
//     <div className="text-center text-white">
//       <h1 className="text-xl font-semibold">Redirecting to the product</h1>
//       <p className="text-sm mt-2">This shouldn't take long</p>
//     </div>
//   </div>
// };

// export default AffiliateRedirect; 
